import React from 'react';
import PropTypes from 'prop-types';
import { allWidgets } from 'components/widgets';
import shouldWrapInAdmin from '../../../../../modules/widgets/shouldWrapInAdmin';
import WidgetLoader from '../../../../../admin/containers/WidgetLoader';
import LegacyWidgetLoader from '../containers/WidgetLoader';
import DeletedWidget from './DeletedWidget';
import SubsectionDropZone from './SubsectionDropZone';
import style from './Subsection.scss';

export default class Subsection extends React.Component {
  static propTypes = {
    widget: PropTypes.object,
    accepts: PropTypes.arrayOf(PropTypes.string),
    isEditing: PropTypes.any,
    onWidgetEditStart: PropTypes.func,
    onDrop: PropTypes.func.isRequired,
    onFinishEdit: PropTypes.func,
    onCancelEdit: PropTypes.func,
    onDelete: PropTypes.func,
    position: PropTypes.number.isRequired,
    onStartWidgetSwitch: PropTypes.func,
    onSwitchWidgets: PropTypes.func,
    legacyWidgetLoader: PropTypes.bool,
  };

  static defaultProps = {
    isEditing: false,
    legacyWidgetLoader: true,
  };

  wrapHandler = fn => (...args) => this.props[fn](this.props.widget.id, ...args);

  handleEditStart = (...args) => {
    const { onWidgetEditStart, widget: { id, type } } = this.props;
    onWidgetEditStart(id, { type, ...args });
  };
  handleFinishEdit = this.wrapHandler('onFinishEdit');
  handleCancelEdit = this.wrapHandler('onCancelEdit');
  handleDelete = this.wrapHandler('onDelete');
  handleStartWidgetSwitch = this.wrapHandler('onStartWidgetSwitch');

  handleDrop = (...args) => this.props.onDrop(this.props.position, ...args);

  renderWidget = () => {
    const {
      widget, onDrop, accepts, isEditing, onSwitchWidgets, legacyWidgetLoader, ...props
    } = this.props;

    let widgetComponent = false;
    if (widget) {
      const widgetProps = {
        ...widget,
        ...props,
        onWidgetEditStart: this.handleEditStart,
        onFinishEdit: this.handleFinishEdit,
        onCancelEdit: this.handleCancelEdit,
        onDelete: this.handleDelete,
        onStartWidgetSwitch: this.handleStartWidgetSwitch,
        onSwitchWidgets,
      };
      widgetProps.isEditing = !!isEditing;
      if (typeof isEditing === 'string') {
        widgetProps.editChannel = isEditing;
      }
      widgetComponent = legacyWidgetLoader ?
        <LegacyWidgetLoader {...widgetProps} /> :
        <WidgetLoader {...widgetProps} />;
    } else {
      widgetComponent = <DeletedWidget {...props} />;
    }

    const acceptAll = Object.keys(allWidgets);

    const subsectionProps = {
      onDrop: this.handleDrop,
      accepts: acceptAll,
    };

    if (widget && !shouldWrapInAdmin(widget.componentId)) {
      return widgetComponent;
    }

    return (
      <SubsectionDropZone {...subsectionProps}>
        {widgetComponent}
      </SubsectionDropZone>
    );
  };

  render() {
    const { isEditing, widget } = this.props;
    const classNames = [];
    if (widget && shouldWrapInAdmin(widget.componentId)) {
      classNames.push(style.root);
    }

    if (isEditing) {
      classNames.push(style.active);
    }

    return (
      <div className={classNames.join(' ')}>
        {this.renderWidget()}
      </div>
    );
  }
}
